import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-633c38fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toolbar__buttons" }

import { IonTitle, IonToolbar, IonHeader, IonButton, } from '@ionic/vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'StartStocktakingHeader',
  props: {
    isClearPlacementsDisabled: { type: Boolean }
  },
  emits: ['onClearPlacements'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
    isClearPlacementsDisabled: boolean;
};





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonHeader), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonToolbar), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonTitle), null, {
            default: _withCtx(() => [
              _createTextVNode("WMS | Register placements")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonToolbar), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonButton), {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClearPlacements'))),
              disabled: props.isClearPlacementsDisabled
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Clear placements ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})